/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ActivityLogView,
    ActivityLogViewFromJSON,
    ActivityLogViewToJSON,
    BDOperation,
    BDOperationFromJSON,
    BDOperationToJSON,
    EntityType,
    EntityTypeFromJSON,
    EntityTypeToJSON,
} from '../models';

export interface UpdateHistoryV2ActivitylogGetRequest {
    from?: Date;
    to?: Date;
}

export interface UpdateHistoryV2HistoryGetRequest {
    id?: string;
    type?: EntityType;
}

/**
 * no description
 */
export class UpdateHistoryV2Api extends runtime.BaseAPI {

    /**
     */
    async updateHistoryV2ActivitylogGetRaw(requestParameters: UpdateHistoryV2ActivitylogGetRequest): Promise<runtime.ApiResponse<Array<ActivityLogView>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = (requestParameters.from as any).toISOString();
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = (requestParameters.to as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/UpdateHistoryV2/activitylog`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ActivityLogViewFromJSON));
    }

    /**
     */
    async updateHistoryV2ActivitylogGet(requestParameters: UpdateHistoryV2ActivitylogGetRequest): Promise<Array<ActivityLogView>> {
        const response = await this.updateHistoryV2ActivitylogGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async updateHistoryV2HistoryGetRaw(requestParameters: UpdateHistoryV2HistoryGetRequest): Promise<runtime.ApiResponse<Array<BDOperation>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/UpdateHistoryV2/history`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BDOperationFromJSON));
    }

    /**
     */
    async updateHistoryV2HistoryGet(requestParameters: UpdateHistoryV2HistoryGetRequest): Promise<Array<BDOperation>> {
        const response = await this.updateHistoryV2HistoryGetRaw(requestParameters);
        return await response.value();
    }

}
